import getters from './leadGenGetters'
import actions from './leadGenActions'
import mutations from './leadGenMutations'
import { normalizeLeadGenAnswers } from '../shared/leadGenAnswers'

const STORAGE_KEY = 'leadGenFlow'

const loadFromStorage = () => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error('Failed to load from session storage:', error)
    return null
  }
}

const savedData = loadFromStorage() || {}

const conversationalState = () => ({
  isInConversationalFlow: savedData.isInConversationalFlow || false,
  conversationalChatId: savedData.conversationalChatId || null,
  conversationalLeadData: savedData.conversationalLeadData || {},
  conversationalContactCollected: savedData.conversationalContactCollected || false,
  conversationalLeadComplete: savedData.conversationalLeadComplete || false,
  conversationalPrequalComplete: savedData.conversationalPrequalComplete || false,
  conversationalMessages: savedData.conversationalMessages || [],
  conversationalQuestionKeys: savedData.conversationalQuestionKeys || null,
  conversationalCurrentQuestionKey: savedData.conversationalCurrentQuestionKey || null,
  conversationalQuickReplies: savedData.conversationalQuickReplies || [],
  conversationalQuickRepliesAreSuggestions: savedData.conversationalQuickRepliesAreSuggestions || false,
  conversationalConsentSubmitted: savedData.conversationalConsentSubmitted || false
})

const store = {
  namespaced: true,
  state: () => ({
    leadGenQuestions: savedData?.leadGenQuestions || [],
    answers: normalizeLeadGenAnswers(savedData?.answers || {}),
    orgGuid: savedData?.orgGuid || null,
    orgId: null,
    orgType: savedData.orgType || null,
    settings: savedData.settings || {
      landingPageTitle: null,
      submissionPageBodyText: null,
      prequalHardCreditAllowed: false,
      purchaseFlow: false,
      refinanceFlow: false,
      prequalFlow: false,
      autoRunLpa: false,
      autoRunDu: false,
      conversationalFlow: false,
      hasGenAiTenant: false,
      name: null,
      orgIcon: null,
      orgAppIcon: null,
      servicerImageUrl: null,
      servicerInitials: null,
      partnerImageUrl: null,
      partnerInitials: null
    },
    servicer: null,
    leadGenQuestionCount: savedData.leadGenQuestionCount || 0,
    prequalQuestionCount: savedData.prequalQuestionCount || 0,
    currentQuestionIndex: savedData.currentQuestionIndex || 0,
    formSubmitted: false,
    sac: savedData.sac || null,
    leadId: savedData.leadId || null,
    selectedLoanType: savedData.selectedLoanType || null,
    previewForm: false,
    previewQuestion: false,
    showLandingPage: false,
    hasVisitedLandingPage: false,
    completionPageType: savedData.completionPageType || null,
    hasAccount: savedData.hasAccount || false,
    letterGuid: savedData.letterGuid || null,
    artifactGuid: savedData.artifactGuid || null,
    // Conversational flow state
    ...conversationalState()
  }),
  getters,
  actions,
  mutations
}

export default store
